<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
   
    <template v-if="templates!=null">
     
        <v-card class="box">
           <v-col cols="12" sm="12" md="12">
      <center class="heading">
        <h3>Create Template</h3>
    </center>
    <br>
          <v-data-table :headers="headers" :items="templates" class="elevation-1">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <!-- <v-toolbar-title>Templates</v-toolbar-title> -->
                <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
                <!-- <v-spacer></v-spacer> -->
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-row justify="center">
                    <v-btn class="button" v-on="on">Add New Template</v-btn>
                    </v-row>
                  </template>
                  <v-card>
                    <v-card-title class="heading">
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model.trim="editedItem.name" label="Template Name"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-checkbox v-model="editedItem.isactive" class="mx-2" label="Active"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="button-cancel"  @click="close">Cancel</v-btn>
                      <v-btn class="button" :loading="save_btn_load"  @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.isactive="{ item }">
              <v-icon
                v-if="item.isactive==true"
                color="success"
                class="mr-2"
              >mdi-check-circle-outline</v-icon>
              <v-icon v-else color="error" class="mr-2">mdi-close-circle-outline</v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            </template>
          </v-data-table>
              </v-col>
        </v-card>
  
    </template>
  </div>
</template>


<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data: () => ({
    snackbar_msg: "",
    snackbar: false,
    color: "",
    org: null,
    dialog: false,
    save_btn_load: false,
    //
    templates: null,
    headers: [
      { text: "Name", value: "name" },
      { text: "Activate?", value: "isactive" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      name: "",
      isactive: true
    },
    defaultItem: {
      name: "",
      isactive: true
    }
  }),
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(item) {
      this.editedIndex = this.templates.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedItem.name == "" || this.editedItem.name == null) {
        this.showSnackbar("#b71c1c", "Please add name!!!");
        return;
      }
      if (this.editedIndex > -1) {
        this.save_btn_load = true;
        axios
          .post("/QPTemplate/editTemplate", this.editedItem)
          .then(res => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4CAF50", "Edited Successfully.");
              this.templates = res.data.templates;
            } else {
              this.showSnackbar("#b71c1c", "Cant edit, may be duplicate entry!!!");
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {
            this.save_btn_load = false;
          });
      } else {
        this.save_btn_load = true;
        axios
          .post("/QPTemplate/saveTemplate", this.editedItem)
          .then(res => {
            if (res.data.status == "YES") {
              this.showSnackbar("#4CAF50", "Added Successfully.");
              this.templates = res.data.templates;
              //this.templates.push(this.editedItem);
            } else {
              this.showSnackbar("#b71c1c", "Already added!!!");
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {
            this.save_btn_load = false;
          });
      }
      this.close();
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Template" : "Edit Template";
    }
  },
  mounted() {
    axios
      .post("/QPTemplate/template")
      .then(res => {
        this.org = res.data.org;
        this.templates = res.data.templates;
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong!!!");
      })
      .finally(() => {});
  }
};
</script>
<style scoped>
       .box {
    background-color: #a9d9ec49;
    margin: 8px !important;
    padding: 10px;
    border: 2px solid hsla(190, 99%, 30%, 1) !important;
    border-radius: 10px;
}
</style>